import React, { createContext, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";

export const AnalyticsHubContext = createContext({
  pages: [],
  setPages: () => {},
  isLoading: true,
});

export const AnalyticsHubProvider = ({ children }) => {
  const [pages, setPages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleSetPages = useCallback((newPages) => {
    setPages(newPages);
    setIsLoading(false);
  }, []);

  const value = useMemo(
    () => ({
      pages,
      setPages: handleSetPages,
      isLoading,
    }),
    [pages, handleSetPages, isLoading]
  );

  return (
    <AnalyticsHubContext.Provider value={value}>
      {children}
    </AnalyticsHubContext.Provider>
  );
};

AnalyticsHubProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
